/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";
import { Routes, Route, useNavigate } from 'react-router-dom';

import { Row, Col, Button, Table } from "react-bootstrap";

//import { useAuth, useDispatcher } from "../components/AuthProvider"

import Dashboard from "./panels/Dashboard";

import Milestones from "./panels/Milestones";
import AddMilestone from "./panels/AddMilestone";
import EditMilestone from "./panels/EditMilestone";

import Accounts from "./panels/Accounts";
import AddAccount from "./panels/AddAccount";
import EditAccount from "./panels/EditAccount";
import AccountCalendar from "./panels/AccountCalendar";
import AccountDetails from "./panels/AccountDetails";

import Items from "./panels/Items";
import AddItem from "./panels/AddItem";
import EditItem from "./panels/EditItem";

import Debugger from "./panels/Debugger";



function Planner() {
  const navigate = useNavigate();
  //const results = useAuth();


  function selectHome(event) {
    event.preventDefault();
    navigate("/app/planner/");
  }

  function selectMilestones(event) {
    event.preventDefault();
    navigate("/app/planner/milestones");
  }

  function selectAccounts(event) {
    event.preventDefault();
    navigate("/app/planner/accounts");
  }

  function selectItems(event) {
    event.preventDefault();
    navigate("/app/planner/items");
  }

  function selectDebugger(event) {
    event.preventDefault();
    navigate("/app/planner/debugger");
  }


  const icon_row_style = {
    paddingTop: "5px",
    paddingBottom: "5px"
  }

  const div_style = {
    //"fontSize": "0.8em"
  };


  return (
    <Row>
      <Col>
        <Row style={div_style}>
          <Col>
            <Icon name="home" title="Home" onClick={selectHome} />
            <Icon name="calendar" title="Milestones" onClick={selectMilestones} />
            <Icon name="money-check-alt" title="Accounts" onClick={selectAccounts} />
            <Icon name="list" title="Items" onClick={selectItems} />

            <Icon name="bug" title="Debugger" onClick={selectDebugger} />
          </Col>
        </Row>

        <Row style={div_style}>
          <Col>

            <Routes>
              <Route index element={<Dashboard />} />

              <Route path="milestones/add" element={<AddMilestone />} />
              <Route path="milestones/:id/edit" element={<EditMilestone />} />
              <Route path="milestones" element={<Milestones />} />

              <Route path="accounts/add/:type" element={<AddAccount />} />
              <Route path="accounts/:id/edit" element={<EditAccount />} />
              <Route path="accounts/:id/calendar" element={<AccountCalendar />} />
              <Route path="accounts/:id/details" element={<AccountDetails />} />
              <Route path="accounts" element={<Accounts />} />

              <Route path="items/add/:type" element={<AddItem />} />
              <Route path="items/:id/edit" element={<EditItem />} />
              <Route path="items" element={<Items />} />

              <Route path="debugger" element={<Debugger />} />
            </Routes>

          </Col>

        </Row>
      </Col>

    </Row>
  );
}


function Icon(props) {
  const icon_style = {
    padding: "5px",
  }

  const fa_icon = `fas fa-${props.name} fa-2x`;

  return <i style={icon_style} className={fa_icon} title={props.title} onClick={props.onClick}></i>
}



export default Planner;


/*

        <Routes>
          <Route index element={<UserList users={users} />} />
          <Route path=":userId" element={<UserItem users={users} />} />
        </Routes>

*/